import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import ApplicationHeader from "../../../application/ApplicationHeader";
import logo from "../../../application/BiblioBoard_Logo_Stacked.png";
import { Container } from "@mui/material";
import ApplicationPanel from "../../../application/ApplicationPanel";
import SipServerBrowse from "./SipServerBrowse";

const useStyles = makeStyles(theme => ({
  panel: {
    padding: 0,
  },

  creatorLogo: {
    width: "100%",
    height: "100%",
  },
}));

const ManageSipServers = () => {
  const classes = useStyles();

  return (
    <Container
      id="manage-sip-servers"
      maxWidth={false}
      classes={{ root: classes.panel }}
    >
      <ApplicationHeader
        applicationLogo={
          <img className={classes.creatorLogo} alt="Creator" src={logo} />
        }
        applicationNavigationWidth="33%"
      />

      <ApplicationPanel>
        <SipServerBrowse />
      </ApplicationPanel>
    </Container>
  );
};

export default ManageSipServers;
